import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Page } from "../../components/page/page";
import { StatusMessage } from "../../components/status-message/statusMessage";
import { useLocalization } from "../../hooks/use-localization/useLocalization";
import { useQuery } from "../../hooks/use-query/useQuery";
import { useUser } from "../../hooks/use-user/useUser";
import { useApp } from "../../hooks/use-app/useApp";
import { getErrorText } from "../../util/error/getErrorText";

export const EmailVerified: React.FC = () => {
  const { localize } = useLocalization();
  const { user } = useUser();
  const app = useApp();
  const { error, refreshed } = useQuery();

  useEffect(() => {
    if (
      !user &&
      !refreshed &&
      !error &&
      !window.location.search.includes("refreshed")
    ) {
      // We do this since links from email clients might NOT send cookies.
      window.location.href = window.location.href + "?refreshed=true";
    }
  }, [error, user, refreshed]);

  return (
    <Page>
      {error ? (
        <StatusMessage type="error">
          {getErrorText(error, {
            token_already_used: localize("error:emailVerifytokenAlreadyUsed"),
          })}
        </StatusMessage>
      ) : (
        <StatusMessage type="success">
          {localize("emailConfirmed")}
        </StatusMessage>
      )}
      {user ? (
        <a className="button" href={`/${app.name}/api/autologin`}>
          {localize("login:action")}
        </a>
      ) : (
        <Link className="button" to={`/${app.name}/logg-inn`}>
          {localize("login:action")}
        </Link>
      )}
    </Page>
  );
};
